
import Vue from "vue";
import Tables from "@/components/Tables";
import SNCBillingBoard from "@/components/Tables/SNCBillingBoard";
import MemberReview from "@/components/Tables/MemberReview";
import FirstShiftBooked from "@/components/Tables/FirstShiftBooked";
import Hygienist from "@/components/Tables/Hygienist";
import DailyShiftList from "@/components/Tables/DailyShiftList";
import Location from "@/components/Tables/Location";
import Invoice from "@/components/Tables/Invoice";
import Job from "@/components/Tables/Job";
import Shift from "@/components/Tables/Shifts";
import User from "@/components/Tables/User";
import { mapMutations, mapState } from "vuex";
import { filterDays } from "@/api";
import { formatDates, getHeaders } from "@/helpers";
import { constants } from "@/utils/constants";
import { jobPrefetchPaginationPayload } from "@/helpers/jobLinkedSearch";

export default Vue.extend({
  props: {
    tablename: String
  },
  components: {
    Tables,
    SNCBillingBoard,
    MemberReview,
    FirstShiftBooked,
    Hygienist,
    DailyShiftList,
    Invoice,
    Location,
    Job,
    Shift,
    User
  },
  data() {
    return {
      foundDays: 3,
      loading: true,
      filterDays: null,
      inputPlaceholder: "",
      hiddenSearchForm: [
        "DailyShiftList",
        "SNCBillingBoard",
        "BlockedHygienist"
      ]
    };
  },
  async created() {
    this.loading = true;

    if (constants.serverPaginateTables.includes(this.tablename)) {
      // T2-7038: EntityIdLink to /tables/Job?jobId=N used to prefetch page 1
      // unfiltered. Job.vue then set tableSearch, but getDataFromApi bailed
      // because this.loading was still true — the Jobs table showed 0 Total.
      await this.$store.dispatch(
        "getPaginateData",
        jobPrefetchPaginationPayload(
          this.tablename,
          (this as any).$route?.query?.jobId
        )
      );
    } else {
      await this.$store.dispatch("getData", { tablename: this.tablename });
    }

    this.$store.commit("modify", {
      property: "tablename",
      value: this.tablename
    });
    if (this.tablename === "MemberReview") {
      this.inputPlaceholder = "New Members as of last days";
    }
    if (this.tablename === "FirstShiftBooked") {
      this.inputPlaceholder = "First Shift Booked in past days";
    }
    this.foundDays = this.countDays;
    this.loading = false;
  },
  computed: {
    ...mapState({
      countDays: "countDays",
      tableContent: "tableContent"
    }),
    namePageTable(): string {
      return constants.tables[this.tablename] || constants.tables["default"];
    },
    // Server-paginated tables (Job, Hygienist, Location, Shift, Invoice) have
    // their own search input and empty-state UI, so the legacy "last N days"
    // fallback card is not meaningful for them. T2-5696.
    isServerPaginated(): boolean {
      return constants.serverPaginateTables.includes(this.tablename);
    }
  },
  methods: {
    ...mapMutations(["modify", "modifyMultiple"]),
    async searchFilterDays() {
      this.loading = true;
      let data = await filterDays(this.countDays, this.tablename.toLowerCase());
      if (data) {
        const headers = data.length ? getHeaders(data) : [];
        this.modifyMultiple([
          {
            property: "tableHeaders",
            value: headers
          },
          {
            property: "tableContent",
            value: data.length ? formatDates(data) : []
          }
        ]);
        this.foundDays = this.countDays;
        this.loading = false;
      }
    },
    updateCountDays(value: number) {
      this.modify({
        property: "countDays",
        value: value
      });
    }
  }
});
